import { render, staticRenderFns } from "./error404Mobile.vue?vue&type=template&id=32f194f8&scoped=true"
import script from "./error404Mobile.vue?vue&type=script&lang=js"
export * from "./error404Mobile.vue?vue&type=script&lang=js"
import style0 from "./error404Mobile.vue?vue&type=style&index=0&id=32f194f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f194f8",
  null
  
)

export default component.exports